import dataQuality from './dataQuality.json';

export default {
    ...dataQuality,
};
